import axios, {
    AxiosError,
    AxiosResponse,
    InternalAxiosRequestConfig,
} from 'axios';
import { LocalStorageItems } from '../constants';
import { getLocalStorageItem, removeLocalStorageItem } from '../utils/localStorage';

interface ApiErrorResponse {
    message?: string;
    success?: boolean;
    error?: string;
}

// Create instance
export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const token = getLocalStorageItem(LocalStorageItems.TOKEN);

        if (token) {
            const tokenValue = typeof token === 'string' ? token : JSON.parse(token as string);
            config.headers.Authorization = `Bearer ${tokenValue}`;
        }

        // Your custom header
        config.headers.triggerSource = 'user';

        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,

    (error: AxiosError<ApiErrorResponse>) => {
        if (error.response?.status === 401) {
            removeLocalStorageItem(LocalStorageItems.TOKEN);

            if (window.location.pathname !== '/login') {
                window.location.href = '/login?reason=session_expired';
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;